// Imports for external libraries go here.
import React from 'react';
import clsx from 'clsx';
import { EditableComponent } from '@adobe/aem-react-editable-components';

// Imports for internal (to the monorepo) libraries go here
import { CardHorizontalFeature as CardHorizontalFeatureCom } from '@marriott/mi-ui-library';
import { useCheckBreakpoint } from '@marriott/mi-ui-library';
import { StyledCardHorizontalFeature } from './CardHorizontalFeature.styles';
import { CardHorizontalFeatureProps } from './CardHorizontalFeature.types';
import { useDCADynamicModelAlloy } from '../../modules/helpers';

const CardHorizontalFeatureComp = (props: CardHorizontalFeatureProps) => {
  const mboxParam = props?.mboxParameter;

  /***
   * Makes the call to target if mboxParam is authored
   */
  const targetResponse = useDCADynamicModelAlloy(mboxParam);
  const targetData = targetResponse?.targetData;

  /**
   * Replacing the AEM model data with target data if target Response is present
   */
  const model = targetData ? targetData : props;
  const isViewportM = useCheckBreakpoint('viewportM');
  return (
    <div className={model?.styleclass}>
      <StyledCardHorizontalFeature className="container">
        <CardHorizontalFeatureCom
          {...model}
          styleclass={clsx(
            isViewportM && model?.assetVariation === 'video' && model?.imageAlignment === 'right'
              ? 'flex-row-reverse'
              : '',
            'card-horizontal-container',
            model?.styleclass
          )}
          btnClassName={clsx(
            model?.ctaType === 'primaryButton' || model?.ctaType === 'secondaryButton' ? 'm-button-s cta-btn' : ''
          )}
        />
      </StyledCardHorizontalFeature>
    </div>
  );
};

export const CardHorizontalFeatureConfig = {
  emptyLabel: 'CardHorizontalFeature',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/common/cardhorizontalfeature`,
};

export const CardHorizontalFeature = (props: CardHorizontalFeatureProps) => (
  <div
    data-testid="card-horizontal-feature"
    data-component-name="o-common-static-cardhorizontalfeature"
    className="m-container-fullbleed"
  >
    <EditableComponent config={CardHorizontalFeatureConfig} {...props}>
      <CardHorizontalFeatureComp {...props} colorClass="color-scheme1" />
    </EditableComponent>
  </div>
);
